module.exports = __webpack_public_path__ + "img/img-block.05fc0771.svg";